// @flow
import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

export default styled.div`
  box-shadow: inset 0 1px 0 ${buildColor("grey", "300")};
`;
